import { requestAuth, request } from "common-frontend-components";
import { appConfig } from "../variables/appConfig";
export const setProductDates = (i) => {
    i.created = new Date(i.created);
    if (i.saleStartDate)
        i.saleStartDate = new Date(i.saleStartDate);
    if (i.saleStopDate)
        i.saleStopDate = new Date(i.saleStopDate);
};
export const sortProducts = (products) => {
    const indexed = [];
    const unindexed = [];
    products.forEach(i => {
        if (i.index === undefined)
            unindexed.push(i);
        else
            indexed.push(i);
    });
    indexed.sort((a, b) => {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        // @ts-ignore
        return a.index - b.index;
    });
    unindexed.sort((a, b) => {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        // @ts-ignore
        return b.created - a.created;
    });
    return [...indexed, ...unindexed];
};
export function callGetProductsAsync() {
    return request.get(`${appConfig.productsUrl}`)
        .then(products => {
        products.forEach(setProductDates);
        return sortProducts(products);
    });
}
export function callCreateProductAsync(product) {
    return requestAuth.post(`${appConfig.productsUrl}`, product)
        .then(i => {
        setProductDates(i);
        return i;
    });
}
export function callEditProductAsync(productId, product) {
    return requestAuth.patch(`${appConfig.productsUrl}/${productId}`, product)
        .then(i => {
        setProductDates(i);
        return i;
    });
}
export function callDeleteProductAsync(productId) {
    return requestAuth.delete(`${appConfig.productsUrl}/${productId}`);
}
//# sourceMappingURL=products.js.map